import { render } from "./LootBoxBalance.vue?vue&type=template&id=a03db6ce"
import script from "./LootBoxBalance.vue?vue&type=script&lang=js"
export * from "./LootBoxBalance.vue?vue&type=script&lang=js"

import "./LootBoxBalance.vue?vue&type=style&index=0&id=a03db6ce&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__